import { render, staticRenderFns } from "./Videoconferencing.vue?vue&type=template&id=04d9490c&scoped=true&"
import script from "./Videoconferencing.vue?vue&type=script&lang=js&"
export * from "./Videoconferencing.vue?vue&type=script&lang=js&"
import style0 from "./Videoconferencing.vue?vue&type=style&index=0&id=04d9490c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d9490c",
  null
  
)

export default component.exports